import React from "react";

const SystemProfileContext = React.createContext();

export default SystemProfileContext;
